import type { DoseChangeHold } from "@/lib/api/doseChangeHolds";

/** The message that opened a dose-change request, after the patient's earlier
 * messages from the same chat. The opening message is often a follow-up
 * ("Respond please.") to an ask made earlier that was never recorded on its
 * own, so read both before deciding. Requests recorded before the earlier
 * messages were kept show only the opening message. */
export function DoseRequestMessage({
  hold,
}: {
  hold: Pick<DoseChangeHold, "source_message" | "source_context">;
}) {
  const earlier = hold.source_context ?? [];
  return (
    <div className="flex flex-col gap-8">
      {earlier.length > 0 && (
        <details open>
          <summary className="text-12 cursor-pointer">
            Earlier messages from the patient ({earlier.length})
          </summary>
          <div className="flex flex-col gap-5 pt-5">
            {earlier.map((turn, index) => (
              <blockquote
                key={index}
                className="text-14 whitespace-pre-wrap break-words border-l-2 border-line pl-8 text-ink-muted"
              >
                {turn.text}
                {turn.at && (
                  <span className="block text-12">
                    {new Date(turn.at).toLocaleString()}
                  </span>
                )}
              </blockquote>
            ))}
          </div>
        </details>
      )}
      <div className="flex flex-col gap-5">
        {earlier.length > 0 && (
          <p className="text-12">Message that opened this request:</p>
        )}
        <blockquote className="text-14 whitespace-pre-wrap break-words">
          {hold.source_message || "No message text was captured."}
        </blockquote>
      </div>
    </div>
  );
}
